import React from 'react';
import { useTheme } from '@creditas-ui/system';

var IconPlaceholder = _ref => {
  var {
    variant
  } = _ref;
  var {
    avatar
  } = useTheme();
  var theme = {
    dark: {
      opacity: avatar('icon.opacity'),
      backgroundColor: avatar('dark.backgroundColor')
    },
    light: {
      opacity: avatar('icon.opacity'),
      backgroundColor: avatar('light.backgroundColor')
    }
  };
  return /*#__PURE__*/React.createElement("svg", {
    width: "135%",
    height: "135%",
    viewBox: "0 0 74 74",
    fill: "none",
    preserveAspectRatio: "xMidYMin slice",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "74",
    height: "74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.325 57.1222C18.2766 57.1697 18.2496 57.2347 18.25 57.3025C18.2505 57.3702 18.2784 57.4349 18.3274 57.4817C23.2089 62.1391 29.7447 65.0001 36.9291 65.0001H36.9294C43.9394 64.9921 50.6679 62.2406 55.675 57.3344C55.7234 57.287 55.7504 57.222 55.75 57.1542C55.7495 57.0865 55.7216 57.0218 55.6726 56.975C50.7911 52.3175 44.2553 49.4565 37.0709 49.4565L37.0706 49.4565C30.0606 49.4646 23.3321 52.2161 18.325 57.1222Z",
    fill: "#C4C4C4",
    stroke: "#1F2D27",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.54 24.2935C44.4382 25.1431 45.157 26.1641 45.6538 27.2963C46.1507 28.4284 46.4156 29.6487 46.4328 30.8849C46.4499 32.1212 46.2191 33.3484 45.7539 34.4939C45.2888 35.6394 44.5986 36.6801 43.7244 37.5543C42.8501 38.4286 41.8095 39.1187 40.664 39.5839C39.5184 40.0491 38.2913 40.2799 37.055 40.2627C35.8188 40.2455 34.5985 39.9806 33.4664 39.4838C32.3342 38.9869 31.3132 38.2681 30.4636 37.3699C28.8296 35.6164 27.9401 33.2972 27.9824 30.9008C28.0247 28.5044 28.9955 26.218 30.6902 24.5232C32.385 22.8285 34.6714 21.8577 37.0678 21.8154C39.4642 21.7731 41.7834 22.6626 43.5369 24.2966",
    fill: "#1F2D27"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: theme[variant].opacity,
    cx: "37",
    cy: "37",
    r: "33",
    fill: theme[variant].backgroundColor
  })));
};

export { IconPlaceholder };
//# sourceMappingURL=IconPlaceholder.js.map